/*
 * @Author: wufan 
 * @Date: 2019-08-17 11:01:20 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-10-08 17:45:39
 * 帮助中心-搜索结果页
 */
import React, { useEffect, useState } from 'react';
import './SearchResultPage.less';
import AxiosTS from '../../core/axios';
import {
  withRouter
} from 'react-router-dom';
import HighLightKeyWord from '../util/HighLightKeyWord';
import { Pagination } from 'antd';
import NoResultPage from './NoResultPage';
import BusTs from '../../core/TBus';
import XMTD from '../../core/xmTD';

const SearchResultPage: React.FC = (props: any) => {
  const searchKey = props.location.pathname.indexOf('/', 5) !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";

  const [questionList, setQuestionList] = useState([]);//搜索关键词结果问题列表
  const [totalCount1, setTotalCount1] = useState(0);//搜索结果问题总条数

  const [pageNumber, setPageNumber] = useState(1);
  const [hasResult1, setHasResult1] = useState(false);
  let newVersion = localStorage.getItem('newVersion');

  useEffect(() => { 
    setHasResult1(false);
  }, [searchKey])
  
  useEffect(() => {
    const questionTypeId = newVersion == 'true' ? "d7052befaf024047adcb1cbd8443bf2a" : "3c6e87ce08b9486b806c6f675a56f5df"
    AxiosTS.sobot("search_doc_list", {
      keyFlag: 1,//问题
      // questionTypeId: -1,
      robotFlag: newVersion == 'true' ? 2 : 1,
      // questionTypeFlag: 3,
      pageNo: pageNumber,
      keyWords: searchKey,
      usedFlag: 0,// 默认启用状态
      questionTypeId: questionTypeId,//手动定位到帮助中心模块
    })
      .then((res: any) => {
        if (res.code === "1000") {
          setQuestionList(res.data.items);
          res.data.totalCount && setTotalCount1(res.data.totalCount);
          setHasResult1(true);
        }
      })
      .catch((res: any) => {

      })

  }, [pageNumber, searchKey, newVersion])

  function onChangePageNum(pageNumber: number) {
    setPageNumber(pageNumber);
  }

  // 打点
  function XMDataDot(item:any) { 
    let paramList:any = JSON.parse(localStorage.getItem("ParamsFromB")||"");
    paramList.name = "B端-点击-帮助中心详情";
    paramList.docId = item.docId;
    paramList.questionTitle = item.questionTitle;
    XMTD(paramList);
  }


  function changeRouter(docId: string) {
    props.history.push({
      pathname: `/detail/${docId}`,
      params: {
        docId: docId
      }
    })
    BusTs.emit("initTotal");
  }

  if (!(hasResult1)) {
    return null;
  } else {
    return (
      <div className="search-result-page">
        {questionList.length === 0  ?
          <div className="no-result">
            <NoResultPage />
          </div> :
          <div className="has-result">
            <div className="result-tip">
              搜索“{<span className="keyword">{searchKey}</span>}“的相关结果，共{totalCount1}条
            </div>
            <div className="result-list">
              {questionList.map((item: any, index: number) => {
                return <div className="result-content" onClick={() => {
                  changeRouter(item.docId);
                  XMDataDot(item);
                }}>
                  <div className="title">
                    <HighLightKeyWord text={item.questionTitle} keyword={searchKey} />
                  </div>
                  <div className="context">
                    <HighLightKeyWord text={item.answerTxt.length > 145 ? item.answerTxt.substring(0, 145) + "..." : item.answerTxt} keyword={searchKey} />

                  </div>
                </div>
              })}
            </div>
            <div className="page-control">
              <Pagination showQuickJumper defaultCurrent={1} total={totalCount1} onChange={onChangePageNum} defaultPageSize={15} current={pageNumber} />
            </div>
          </div>
        }
      </div>
    )
  }


}



export default withRouter(SearchResultPage);